import gql from 'graphql-tag'

export const getCandidateBooks = gql`
  query($paging: PagingQuery, $filter: BooksFilter!) {
    getBooks(
      filter: $filter,
      paging: $paging
    ) {
      books {
        id
        name
      }
    }
  }
`

export const getBooks = gql`
  query($filter: BooksFilter!, $paging: PagingQuery, $order: BooksOrder) {
    getBooks(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      books {
        id
        name
        createdAt
        updatedAt
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
      }
      paging { totalCount currentOffset currentLimit }
    }
  }
`

export const getBook = gql`
  query($bookId: Int!) {
    getBook(
      bookId: $bookId
    ) {
      id
      name
      createdAt
      updatedAt
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
    }
  }
`

export const newBook = gql`
  mutation($bookInput: BookInput!) {
    newBook(
      bookInput: $bookInput
    ) {
      id
    }
  }
`

export const editBook = gql`
  mutation($bookInput: BookInput!, $bookId: Int!) {
    editBook(
      bookId: $bookId,
      bookInput: $bookInput
    ) {
      id
    }
  }
`

export const deleteBook = gql`
  mutation($bookId: Int!) {
    deleteBook(
      bookId: $bookId
    )
  }
`
